import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { Message } from 'element-ui'
import { getToken, removeToken } from '@/utils/auth' // getToken from cookie
import { fetchBusinessType } from '@/utils/index'
import { getIntentionTags } from '@/utils/intentionTags/index' // 不重定向白名单

NProgress.configure({ showSpinner: false }) // NProgress configuration

let startTime = Date.now()
let currentTime
router.beforeEach((to, from, next) => funcBeforeEach(to, from, next))

export function funcBeforeEach(to, from, next) {
  // console.info('触发路由跳转', to, from)
  // if (window.__POWERED_BY_QIANKUN__) {
  //   return
  // }

  if (to.matched[0] && to.matched[0].meta.businessType !== 'operating') {
    // 通过当前页面的业务类型，设置相关业务信息，并通过store共享,区分demo模块
    fetchBusinessType(to.matched[0].meta.businessType)
  }
  NProgress.start()
  store.dispatch('setPageName', to.name)
  // if (window.__POWERED_BY_QIANKUN__) {
  //   next()
  // }

  // 如果不需要登录且非登录页直接next
  if (to.path !== '/login' && to.meta.noNeedLogin) {
    next()
    return
  }
  if (!window.__POWERED_BY_QIANKUN__ && getToken()) {
    if (store.getters.product_and_permission.permissions.length === 0) {
      store
        .dispatch('GetInfo')
        .then(res => {
          // 拉取用户信息
          const { intention_annotate, intention, product_and_permission, company, license_info, routerProducePermissions } = res.data.data

          // const { has_license, expire_days } = license_info
          // if (!window.__POWERED_BY_QIANKUN__) {
          //   if (has_license && expire_days > 7) {
          //     Message.error('The license has been expired. Please renew it.')
          //     removeToken()
          //     next({ path: '/login' })
          //     return
          //   }
          // }

          // 获取用户催收、营销、信审业务对应的意向标签
          getIntentionTags(intention_annotate, intention, company)
          store.dispatch('GenerateRoutes', routerProducePermissions).then(accessRoutes => {
            // 根据roles权限生成可访问的路由表
            // console.info(accessRoutes, 'accessRoutes')
            router.addRoutes(accessRoutes) // 动态添加可访问路由表
            if (to.path === '/login') {
              next({ path: '/' })
              NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
            } else {
              NProgress.done()
              next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
            }
          })
        })
        .catch(err => {
          store.dispatch('FedLogOut').then(() => {
            // Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
    } else {
      next()
    }
  } else {
    if (window.__POWERED_BY_QIANKUN__) {
      next()
    } else {
      if (to.path === '/login') {
        next()
      } else {
        next(`/login`) // 否则全部重定向到登录页
        NProgress.done()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/permission.js